export const defaultCookieExpireMinutes = 30;

export function getDateSinceMinutes(minutes) {
  let validMinutes = defaultCookieExpireMinutes;

  if (minutes) {
    try {
      validMinutes = parseInt(minutes);
    } catch (e) {}
  }
  return new Date(new Date().getTime() + parseInt(validMinutes) * 60 * 1000);
}
